import $ from 'jquery';

const $container = $('.su-menu__main-nav'),
	$items = $container.children('.menu-item-has-children');

if ($items.length > 0) {
	$items.map(function () {
		const $menucontainer = $(this).find('.menu'),
			$menuitems = $menucontainer.find('.menu-item');

		$menucontainer.css('height', Math.ceil($menuitems.length / 4) * 56 + 'px');
	});
}


let $menu_items = $('ul.su-menu__main-nav > .menu-item'),
	sub_opened = false;

$menu_items.each( function () {
	let $this = $(this),
		timer;

	$this.on("mouseover", function() {
		clearTimeout(timer);
		if( !sub_opened ) {
			sub_opened = true;
			$(this).addClass('open');
		} else {
			timer = setTimeout( () => {
				$menu_items.removeClass('open');
				$this.addClass('open');
				sub_opened = true;
			}, 250 );
		}
	});

	$this.on("mouseleave", function() {
		clearTimeout(timer);
		timer = setTimeout(() => {
			$this.removeClass('open');
			sub_opened = false;
		}, 250);
	});
} );

